<template>
  <div class="col">
    <div class="row mt-3">
      <div class="col-lg-12">
        <form
          @submit="searchEmailEvents"
        >
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-12 mb-2">
                  <h4>Search Email Events</h4>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="templateName"
                  >
                    To address contains:
                  </label>
                  <input
                    v-model="formSearch.to"
                    type="text"
                    class="form-control"
                    placeholder="e.g. to@gmail.com"
                  >
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="templateName"
                  >
                    Subaccount:
                  </label>
                  <select
                    v-model="formSearch.subaccount"
                    class="form-control"
                  >
                    <option value="">
                      All
                    </option>
                    <option value="ts-clients">
                      ts-clients
                    </option>
                    <option value="ts-internal">
                      ts-internal
                    </option>
                    <option value="propertyalerts">
                      propertyalerts
                    </option>
                    <option value="ts-alerts">
                      ts-alerts
                    </option>
                    <option value="ts-users-signedin">
                      ts-users-signedin
                    </option>
                    <option value="ts-users-notsignedin">
                      ts-users-notsignedin
                    </option>
                  </select>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="templateName"
                  >
                    Event type (none == all):
                  </label>
                  <ul class="in-cboxtags">
                    <li
                      v-for="event in events"
                      :key="event"
                    >
                      <input
                        type="checkbox"
                        v-model="formSearch.eventType"
                        :id="'checkboxEvent_' + event"
                        :value="event"
                      >
                      <label :for="'checkboxEvent_' + event">{{ event }}</label>
                    </li>
                  </ul>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="templateName"
                  >
                    Bounce type (none == all):
                  </label>
                  <ul class="in-cboxtags">
                    <li
                      v-for="bounceType in bounceTypes"
                      :key="bounceType"
                    >
                      <input
                        type="checkbox"
                        v-model="formSearch.bounceType"
                        :id="'checkboxEvent_' + bounceType"
                        :value="bounceType"
                      >
                      <label :for="'checkboxEvent_' + bounceType">{{ bounceType }}</label>
                    </li>
                  </ul>
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="templateName"
                  >
                    Bounce diagnostic code:
                  </label>
                  <input
                    v-model="formSearch.bounceDiagnosticCode"
                    type="text"
                    class="form-control"
                    placeholder="e.g. spam"
                  >
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="templateName"
                  >
                    Subject contains:
                  </label>
                  <input
                    v-model="formSearch.subject"
                    type="text"
                    class="form-control"
                    placeholder="e.g. alert"
                  >
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="templateName"
                  >
                    From contains:
                  </label>
                  <input
                    v-model="formSearch.from"
                    type="text"
                    class="form-control"
                    placeholder="e.g. jobs@thinkspain.com"
                  >
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="templateName"
                  >
                    Tag:
                  </label>
                  <input
                    v-model="formSearch.tag"
                    type="text"
                    class="form-control"
                    placeholder="e.g. for-property-enquiry"
                  >
                </div>
                <div class="col-xl-4 col-lg-6 col-md-6 col-sm-12 form-group">
                  <label
                    class="label label-default"
                    for="templateName"
                  >
                    Days:
                  </label>
                  <select
                    v-model.number="formSearch.days"
                    class="form-control"
                  >
                    <option value="7">
                      7 days
                    </option>
                    <option value="30">
                      30 days
                    </option>
                    <option value="60">
                      60 days
                    </option>
                    <option value="90">
                      90 days
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button
                class="btn btn-secondary float-left"
                @click.prevent="resetFilters"
              >
                Clear All Filters
              </button>
              <button
                class="btn btn-secondary float-left"
                @click.prevent="resetFiltersToDefaults"
                style="margin-left: 10px;"
              >
                Reset to Default Settings
              </button>
              <button
                type="submit"
                class="btn btn-primary float-right"
              >
                <i class="jam jam-search" /> Search
              </button>
            </div>
          </div>
        </form>

        <div class="row mt-3">
          <div class="col-12">
            <div class="table mt-4">
              <table
                id="emailEvents"
                class="w-100 pb-4 pt-4 responsive white-space table-striped"
              >
                <thead>
                  <tr>
                    <th>
                      Event
                    </th>
                    <th>
                      To
                    </th>
                    <th>
                      Event Details
                    </th>
                    <th>
                      Mail
                    </th>
                    <th
                      class="text-right"
                      colspan="2"
                    >
                      Actions
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(emailEvent, i) in emailEvents"
                    :key="i"
                  >
                    <td>{{ emailEvent.eventType }}</td>
                    <td>{{ emailEvent.mail.destination.join( ', ' ) }}</td>
                    <td v-if="emailEvent.eventType === 'Send'">
                      Send
                    </td>
                    <td v-if="emailEvent.eventType === 'Delivery'">
                      Delivered at: {{ toLocalTime( emailEvent.delivery.timestamp ) }}
                      <br>
                      Processing time in ms: {{ emailEvent.delivery.processingTimeMillis }}
                      <br>
                      Recipients: {{ emailEvent.delivery.recipients.join( ', ' ) }}
                      <br>
                      Smtp response: {{ emailEvent.delivery.smtpResponse }}
                    </td>
                    <td v-if="emailEvent.eventType === 'Bounce'">
                      At: {{ toLocalTime( emailEvent.bounce.timestamp ) }}
                      <br>
                      Bounce type: {{ emailEvent.bounce.bounceType }}
                      <br>
                      Bounce sub type: {{ emailEvent.bounce.bounceSubType }}
                      <br>
                      Reporting MTA: {{ emailEvent.bounce.reportingMTA }}
                      <br>
                      Bouced recipients:
                      <ul>
                        <li
                          v-for="recipient in emailEvent.bounce.bouncedRecipients"
                          :key="recipient.emailAddress"
                        >
                          {{ recipient.emailAddress }}, action: {{ recipient.action }}, status: {{ recipient.status }}, diagnostic code: {{ recipient.diagnosticCode }}
                        </li>
                      </ul>
                    </td>
                    <td v-if="emailEvent.eventType === 'Open'">
                      At: {{ toLocalTime( emailEvent.open.timestamp ) }}
                      <br>
                      User agent: {{ emailEvent.open.userAgent }}
                      <br>
                      Ip address: {{ emailEvent.open.ipAddress }}
                    </td>
                    <td v-if="emailEvent.eventType === 'DeliveryDelay'">
                      At: {{ toLocalTime( emailEvent.deliveryDelay.timestamp ) }}
                      <br>
                      Delay type: {{ emailEvent.deliveryDelay.delayType }}
                      <br>
                      <li
                        v-for="recipient in emailEvent.deliveryDelay.delayedRecipients"
                        :key="recipient.emailAddress"
                      >
                        {{ recipient.emailAddress }}, status: {{ recipient.status }}, diagnostic code: {{ recipient.diagnosticCode }}
                      </li>
                    </td>
                    <td v-if="emailEvent.eventType === 'Complaint'">
                      At: {{ toLocalTime( emailEvent.complaint.timestamp ) }}
                      <br>
                      Subtype: {{ emailEvent.complaint.complaintSubType }}
                      <br>
                      Recipients: {{ emailEvent.complaint.complainedRecipients.map(r => r.emailAddress).join( ', ' ) }}
                      <br>
                      User agent: {{ emailEvent.complaint.userAgent }}
                      <br>
                      Complaint feedback type: {{ emailEvent.complaint.complaintFeedbackType }}
                      <br>
                      Arrival date: {{ emailEvent.complaint.arrivalDate }}
                    </td>
                    <td v-if="emailEvent.eventType === 'Reject'">
                      Reason: {{ emailEvent.reject.reason }}
                    </td>
                    <td>
                      sent: {{ toLocalTime( emailEvent.mail.timestamp ) }}
                      <br>
                      to: {{ emailEvent.mail.destination.join( ', ' ) }}
                      <br>
                      from: {{ emailEvent.mail.source }}
                      <br>
                      subject: {{ emailEvent.mail.commonHeaders.subject }}
                      <br>
                      tags: {{ twcTags(emailEvent) }}
                    </td>
                    <td>
                      <button
                        class="btn btn-sm"
                        @click="view(emailEvent.mail.messageId)"
                      >
                        View Content
                      </button>
                    </td>
                    <td>
                      <button
                        class="btn btn-sm"
                        @click="openResend(emailEvent)"
                      >
                        Resend
                      </button>
                    </td>
                  </tr>
                </tbody>
                <tfoot />
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      :class="`modal fade px-0 ${resendMode ? 'show d-block' : 'd-none'}`"
      tabindex="-1"
      role="dialog"
    >
      <div
        class="modal-dialog"
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              Resend Email
            </h5>
            <button
              type="button"
              class="close"
              @click="closeResendMode"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body container-fluid text-center">
            <div class="row">
              <div
                data-field-email=""
                class="col-12 mb-2"
              >
                <input
                  type="email"
                  class="form-control"
                  v-model="resendEmail"
                  placeholder="someone@thinkspain.com"
                >
              </div>
              <div
                data-field-email=""
                class="col-12 mb-2"
              >
                <input
                  type="checkbox"
                  id="reactivateEmail"
                  v-model="reactivateOriginalDestination"
                >
                <label for="reactivateEmail">Reactivate emails for {{ resendOriginalDestination }}</label>
              </div>
              <div
                data-field-button=""
                class="col-12"
              >
                <button
                  class="btn btn-primary btn-block mt-2"
                  @click="resend"
                >
                  Resend email
                </button>
                <button
                  class="btn btn-primary btn-block mt-2"
                  @click="reactivateEmail"
                >
                  Just Reactivate, do not send email
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import http from '../../../../http';
import notify from '../../../../notifications';

let getDefaultFilters = function() {
    return {
        to: '',
        subaccount: 'ts-clients',
        eventType: [ 'Reject', 'Bounce with diagnostic code', 'Complaint' ],
        subject: '',
        from: '',
        tag: '',
        bounceType: [ ],
        bounceDiagnosticCode: '',
        days: 7
    };
};

let getClearedFilters = function() {
    return {
        to: '',
        subaccount: '',
        eventType: [  ],
        subject: '',
        from: '',
        tag: '',
        bounceType: [ ],
        bounceDiagnosticCode: '',
        days: 7
    };
};

export default {
    data() {
        return {
            events: [ 'Send', 'Reject', 'Bounce', 'Bounce with diagnostic code', 'Complaint', 'Delivery', 'Open', 'DeliveryDelay' ],
            bounceTypes: [ 'Undetermined', 'Permanent', 'Transient' ],
            formSearch: getDefaultFilters(),
            emailEvents: [],
            resendMode: false,
            resendMessageId: null,
            resendOriginalDestination: null,
            reactivateOriginalDestination: true,
            resendEmail: null
        };
    },
    methods: {
        twcTags( emailEvent ) {
            let tags = [];
            for ( const [ key, value ] of Object.entries( emailEvent.mail.tags ) ) {
                if ( key.startsWith( 'twc-tag-' ) ) {
                    for ( let tag of value ) {
                        tags.push( tag );
                    }
                }
            }
            return tags.join( ', ' );
        },
        async searchEmailEvents( e ) {
            e.preventDefault();
            this.$store.dispatch( 'appLoading', true );

            // trim formSearch values before sending
            for ( const key in this.formSearch ) {
                if ( typeof this.formSearch[ key ] === 'string' && this.formSearch[ key ] ) {
                    this.formSearch[ key ] = this.formSearch[ key ].trim();
                }
            }

            const response = await http.post( '/emailevents', this.formSearch );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    title: 'Something went wrong',
                    text: 'Please try again'
                } );
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            const data = await response.json();

            this.emailEvents = data;

            this.$store.dispatch( 'appLoading', false );
        },
        async view( messageId ) {
            this.$store.dispatch( 'appLoading', true );

            const response = await http.get( `/emailevents/message/${messageId}` );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    title: 'Something went wrong',
                    text: 'Please try again'
                } );
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            const data = await response.json();

            this.$store.dispatch( 'appLoading', false );

            let emailPreview = window.open( '', 'emailContent', 'scrollbars=1,width=640,height=480' );

            let content = '';

            if ( data.Content && data.Content.Simple && data.Content.Simple.Body ) {
                if ( data.Content.Simple.Body.Html && data.Content.Simple.Body.Html.Data ) {
                    content = data.Content.Simple.Body.Html.Data;
                } else if ( data.Content.Simple.Body.Text && data.Content.Simple.Body.Text.Data ) {
                    content = '<html><head></head><body><pre>'  + data.Content.Simple.Body.Text.Data + '</pre></body></html>';
                }
            } else if ( data.Message && data.Message.Body && data.Message.Body.Text && data.Message.Body.Text.Data ) {
                content = '<html><head></head><body><pre>'  + data.Message.Body.Text.Data + '</pre></body></html>';
            }

            emailPreview.document.write( content );
        },
        async closeResendMode() {
            this.resendMode = false;
            this.resendEmail = null;
            this.resendOriginalDestination = null;
            this.resendMessageId = null;
        },
        async openResend( emailEvent ) {
            this.resendMode = true;
            this.resendEmail = emailEvent.mail.destination[ 0 ];
            this.resendOriginalDestination = emailEvent.mail.destination[ 0 ];
            this.resendMessageId = emailEvent.mail.messageId;
        },
        async resend() {
            this.$store.dispatch( 'appLoading', true );

            if ( this.reactivateOriginalDestination ) {
                const reactivateResponse = await http.post( 'subscribers/reactivate', {
                    email: this.resendOriginalDestination
                } );

                if ( reactivateResponse.status !== 200 ) {
                    notify( {
                        type: 'error',
                        title: 'Something went wrong',
                        text: 'Please try again'
                    } );
                    this.closeResendMode();
                    this.$store.dispatch( 'appLoading', false );
                    return;
                }
            }

            const response = await http.post( `/emailevents/message/${this.resendMessageId}/resend`, {
                to: this.resendEmail
            } );

            if ( response.status !== 200 ) {
                notify( {
                    type: 'error',
                    title: 'Something went wrong',
                    text: 'Please try again'
                } );
                this.closeResendMode();
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            notify( {
                type: 'success',
                title: 'Email sent successfully'
            } );

            this.closeResendMode();

            this.$store.dispatch( 'appLoading', false );
        },
        async reactivateEmail() {
            this.$store.dispatch( 'appLoading', true );

            const reactivateResponse = await http.post( 'subscribers/reactivate', {
                email: this.resendOriginalDestination
            } );

            if ( reactivateResponse.status !== 200 ) {
                notify( {
                    type: 'error',
                    title: 'Something went wrong',
                    text: 'Please try again'
                } );
                this.closeResendMode();
                this.$store.dispatch( 'appLoading', false );
                return;
            }

            notify( {
                type: 'success',
                title: 'Subscriber reactivated'
            } );

            this.closeResendMode();

            this.$store.dispatch( 'appLoading', false );
        },
        toLocalTime( utcTime ) {
            return new Date( utcTime ).toLocaleString( 'es-ES', {
                timeZone: 'Europe/Madrid',
                timeZoneName: 'short'
            } );
        },
        resetFiltersToDefaults() {
            this.formSearch = getDefaultFilters();
        },
        resetFilters() {
            this.formSearch = getClearedFilters();
        }
    },
    mounted() {
        document.title = 'thinkSPAIN - Email Events';
    }
};
</script>



// WEBPACK FOOTER //
// src/components/dashboard/emailevents/form/index.vue